export const FEATURE_NAMESPACE = 'feature.operator-view'
